import Bottleneck from 'bottleneck';
import { pull } from 'lodash-es';

import { acInfo } from '@looko-corp/acloset-react-kit/src/sentry';
import { noopCallback } from '@looko-corp/acloset-react-kit/src/utils';

import type { GeneratorParams, GeneratorResult } from './types';

type DoneListenerType = (info: Bottleneck.EventInfoRetryable) => void;

export abstract class ThumbnailGeneratorBase {
  protected limiter;
  protected doneListener: DoneListenerType[] = [];
  protected disposed = false;

  constructor(maxConcurrent: number) {
    acInfo(`ThumbnailGeneratorBase concurrency=${maxConcurrent}`);

    this.limiter = new Bottleneck({
      maxConcurrent: Math.max(1, maxConcurrent),
    });

    this.limiter.on('done', info => {
      this.doneListener.forEach(v => {
        v(info);
      });
    });
  }

  async dispose() {
    this.disposed = true;
    await this.limiter.stop({ dropWaitingJobs: true }).catch(noopCallback);
  }

  abstract enqueue(blob: Blob, data: GeneratorParams): Promise<GeneratorResult>;

  addDoneListener(listener: () => void) {
    this.doneListener.push(listener);
    return () => {
      pull(this.doneListener, listener);
    };
  }

  counts() {
    return this.limiter.counts();
  }
}
